import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

function AccountCards() {
  const { t } = useTranslation();

  const cards = useMemo(
    () => [
      {
        title: "account.43",
        subtitle: "account.44",
        p: ["account.45", "account.46", "account.47"],
      },
      {
        title: "account.49",
        subtitle: "account.50",
        p: ["account.51", "account.52", "account.53"],
      },
      {
        title: "account.55",
        subtitle: "account.56",
        p: ["account.57", "account.58", "account.59"],
      },
      {
        title: "account.60",
        subtitle: "account.61",
        p: ["account.62", "account.63", "account.64"],
      },
      {
        title: "account.65",
        subtitle: "account.66",
        p: ["account.67", "account.68", "account.69"],
      },
    ],
    []
  );

  return (
    <div className="mt-[80px] xl:mt-[140px]">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
        <div className="flex items-end justify-between gap-[16px]">
          <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[683px] leading-[1.2]">
            {t("account.42")}
          </p>

          <div className="flex gap-[10px] mt-[6px] flex-shrink-0">
            <button className="accountSwiperPrev">
              <svg xmlns="http://www.w3.org/2000/svg" width="47" height="22" viewBox="0 0 47 22" fill="none">
                <rect x="46.5" y="21.5" width="46" height="21" rx="1.5" transform="rotate(-180 46.5 21.5)" stroke="#061A77"/>
                <path d="M11.6464 10.6464C11.4512 10.8417 11.4512 11.1583 11.6464 11.3536L14.8284 14.5355C15.0237 14.7308 15.3403 14.7308 15.5355 14.5355C15.7308 14.3403 15.7308 14.0237 15.5355 13.8284L12.7071 11L15.5355 8.17158C15.7308 7.97631 15.7308 7.65973 15.5355 7.46447C15.3403 7.26921 15.0237 7.26921 14.8284 7.46447L11.6464 10.6464ZM35 11L35 10.5L12 10.5L12 11L12 11.5L35 11.5L35 11Z" fill="#061A77"/>
              </svg>
            </button>
            <button className="accountSwiperNext">
              <svg xmlns="http://www.w3.org/2000/svg" width="47" height="22" viewBox="0 0 47 22" fill="none">
                <rect x="3.8466e-06" width="47" height="22" rx="2" fill="#061A77"/>
                <path d="M35.3536 11.3536C35.5488 11.1583 35.5488 10.8417 35.3536 10.6465L32.1716 7.46447C31.9763 7.26921 31.6597 7.26921 31.4645 7.46447C31.2692 7.65973 31.2692 7.97631 31.4645 8.17158L34.2929 11L31.4645 13.8284C31.2692 14.0237 31.2692 14.3403 31.4645 14.5355C31.6597 14.7308 31.9763 14.7308 32.1716 14.5355L35.3536 11.3536ZM12 11L12 11.5L35 11.5L35 11L35 10.5L12 10.5L12 11Z" fill="white"/>
              </svg>
            </button>
          </div>
        </div>
        <div className="mt-[30px] xl:mt-[50px]">
          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: ".accountSwiperPrev",
              nextEl: ".accountSwiperNext",
            }}
            slidesPerView={1}
            spaceBetween={12}
            breakpoints={{
              640: { slidesPerView: 1.2 },
              768: { slidesPerView: 2 },
              1280: { slidesPerView: 3, spaceBetween: 20 },
            }}
          >
            {cards.map((c, idx) => (
              <SwiperSlide key={idx} className="!h-auto">
                <div className="h-full bg-[#F2FAF8] rounded-[4px] p-[24px] flex flex-col">
                  <p className="poppins text-[20px] text-[#1A0402] xl:text-[32px] font-[500] leading-[1.2] ">
                    {t(c.title)}
                  </p>
                  <p className="mt-[6px] poppins text-[16px] xl:text-[20px] font-[500]">{t(c.subtitle)}</p>

                  <div className="mt-[16px] text-[14px] text-[#000000B2] flex flex-col gap-[10px]">
                    <p>{t(c.p[0])}</p>
                    <p>{t(c.p[1])}</p>
                    <p>{t(c.p[2])}</p>
                  </div>
                  <div className="mt-auto pt-[20px]">
                    <Button></Button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default AccountCards;
